module.exports = __webpack_public_path__ + "img/tbt23-1-1999.prt.861601d5.jpg";